import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import emptyApi from '@epi-api/emptyApi';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { OnboardingSummaryDTO } from '@epi-models/pages/OnboardingSuccessPage';

export const getOnboardingSummary = async (): Promise<
  | {
      data: OnboardingSummaryDTO;
    }
  | { error: FetchBaseQueryError }
> => {
  try {
    const data: OnboardingSummaryDTO = await get(
      `${config.apiHost}/api/onboarding/summary`
    );
    return { data };
  } catch (error) {
    return { error: error as FetchBaseQueryError };
  }
};

export const onboardingSummaryApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getOnboardingSummary: build.query<OnboardingSummaryDTO, void>({
      queryFn: getOnboardingSummary,
      keepUnusedDataFor: 1800
    })
  })
});

export const { useGetOnboardingSummaryQuery } = onboardingSummaryApi;
